import { render, staticRenderFns } from "./GiftsFromTheWholesomeKitchen.vue?vue&type=template&id=779287ee&scoped=true"
import script from "./GiftsFromTheWholesomeKitchen.vue?vue&type=script&lang=js"
export * from "./GiftsFromTheWholesomeKitchen.vue?vue&type=script&lang=js"
import style0 from "./GiftsFromTheWholesomeKitchen.vue?vue&type=style&index=0&id=779287ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779287ee",
  null
  
)

export default component.exports